/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BackfillStatus } from "./BackfillStatus";
import {
  BackfillStatusFromJSON,
  BackfillStatusFromJSONTyped,
  BackfillStatusToJSON,
  BackfillStatusToJSONTyped,
} from "./BackfillStatus";
import type { BackfillRun } from "./BackfillRun";
import {
  BackfillRunFromJSON,
  BackfillRunFromJSONTyped,
  BackfillRunToJSON,
  BackfillRunToJSONTyped,
} from "./BackfillRun";

/**
 *
 * @export
 * @interface BackfillStatusResponse
 */
export interface BackfillStatusResponse {
  /**
   *
   * @type {Array<BackfillStatus>}
   * @memberof BackfillStatusResponse
   */
  backfills: Array<BackfillStatus>;
  /**
   *
   * @type {Array<BackfillRun>}
   * @memberof BackfillStatusResponse
   */
  recentRuns: Array<BackfillRun>;
}

/**
 * Check if a given object implements the BackfillStatusResponse interface.
 */
export function instanceOfBackfillStatusResponse(
  value: object,
): value is BackfillStatusResponse {
  if (!("backfills" in value) || value["backfills"] === undefined) return false;
  if (!("recentRuns" in value) || value["recentRuns"] === undefined)
    return false;
  return true;
}

export function BackfillStatusResponseFromJSON(
  json: any,
): BackfillStatusResponse {
  return BackfillStatusResponseFromJSONTyped(json, false);
}

export function BackfillStatusResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackfillStatusResponse {
  if (json == null) {
    return json;
  }
  return {
    backfills: (json["backfills"] as Array<any>).map(BackfillStatusFromJSON),
    recentRuns: (json["recentRuns"] as Array<any>).map(BackfillRunFromJSON),
  };
}

export function BackfillStatusResponseToJSON(
  json: any,
): BackfillStatusResponse {
  return BackfillStatusResponseToJSONTyped(json, false);
}

export function BackfillStatusResponseToJSONTyped(
  value?: BackfillStatusResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    backfills: (value["backfills"] as Array<any>).map(BackfillStatusToJSON),
    recentRuns: (value["recentRuns"] as Array<any>).map(BackfillRunToJSON),
  };
}
